import config from "./config";
import { readData } from "../utils/fileHelpers";
import axios from "axios";

const uploadFile = async (folder, data) => {
  let fileData = "";
  let fileName = "data.json";
  let contentType = "application/json";
  let contentEncoding = "";

  if (data.type) {
    fileData = await readData(data);
    fileName = data.name;
    contentType = data.type;
    contentEncoding = "base64";
  } else {
    fileData = JSON.stringify(data);
  }

  const args = {
    Body: fileData,
    Key: `${folder}${fileName}`,
    ContentType: contentType,
    ContentEncoding: contentEncoding,
  };

  // eslint-disable-next-line no-useless-catch
  try {
    const [url, params] = await config("putObject", args);
    return await axios.post(url, params);
  } catch (e) {
    throw e;
  }
};

export default uploadFile;

// { headers: headers }